import { QueryClient } from '@tanstack/react-query';

const defaultBackoff = (attemptIndex: number) =>
  Math.min(1000 * 2 ** attemptIndex, 30000);

/**
 * TODO: Analyze and adjust caching strategies based on app requirements.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      retry: 3,
      retryDelay: defaultBackoff,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});
